import { PanelContent } from '../../layout/PanelContent';

export const NewsAdd = () => {
  return (
    <PanelContent>
      <div>sdfsf</div>
    </PanelContent>
  );
};
